import { render, staticRenderFns } from "./ConfiguracaoContaGeralFoto.vue?vue&type=template&id=d510b8c8"
import script from "./ConfiguracaoContaGeralFoto.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoContaGeralFoto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports